import React, { useState } from 'react';
import { crmRequest } from './crmApi';
export default function CompanyTypeSelect({ company, onSaved, disabled = false }) {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    async function change(type) {
        if (saving || disabled || type === company.type) return;
        setSaving(true); setError('');
        try { onSaved(await crmRequest(`/companies/${company._id}/type`, 'patch', { type, revision: company.revision || 0 })); }
        catch (e) { setError(e.message); }
        finally { setSaving(false); }
    }
    return <div className="crm-inline-type"><select aria-label={`Tipo de ${company.name}`} value={company.type === 'new' ? 'non_customer' : company.type || 'non_customer'} disabled={saving || disabled} onChange={e => change(e.target.value)}>
        <option value="lead">Lead</option><option value="customer">Cliente</option><option value="non_customer">No cliente</option><option value="supplier">Proveedor</option>
    </select>{saving && <small role="status">Guardando…</small>}{error && <small role="alert" className="crm-error">{error}</small>}</div>;
}

